import React from 'react';

export const LazySubscribeRoute = React.lazy(() =>
  import(/* webpackChunkName: "subscribe" */ './Route'),
);
